<template>
    <div>
        <div class="embed-container">
            <iframe
                :src="videoUrl"
                allowFullScreen
                frameborder="0"
                mozallowfullscreen
                webkitAllowFullScreen></iframe>
        </div>
    </div>
</template>

<script>
export default {
  name: 'VimeoEmbed',

  props: {
    videoUrl: {
      type: String,
      required: true,
      default: '/videos/TIS-Dashboard-video.mp4',
    },
  },
};
</script>

<style>
  .embed-container {
    position: relative;
    padding-bottom: 56.25%;
    height: 0;
    overflow: hidden;
    max-width: 100%;
  }

  .embed-container iframe, .embed-container object, .embed-container embed {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
</style>
